export default __webpack_public_path__ + "static/media/background.5815b90f.svg";